module.exports = __webpack_public_path__ + "static/media/opera.ed38582e.svg";